import { ChangeDetectionStrategy, Component, Input, booleanAttribute } from '@angular/core';

@Component({
  selector: 'app-input-wrapper',
  templateUrl: './input-wrapper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputWrapperComponent {
  @Input({ transform: booleanAttribute }) required!: boolean;
  @Input() value!: any;
  @Input() label!: string;
  @Input({ transform: booleanAttribute }) isDisabled = false;
}
